/* eslint-disable */
export enum Shade {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum IconStyle {
  SOLID = 'solid',
  REGULAR = 'regular',
  BRANDS = 'brands',
}
